<template>
    <img
        loading="lazy"
        :src="source"
        :width="width"
        :height="height"
        :alt="altText"
    />
</template>

<script>
export default {
    props: ['src', 'img', 'h', 'w'],
    computed: {
        source: function() {

            if(this.src) {
                var s = this.src;
            }
            else if(this.img){
                var s = this.img.url;
            }
            else {
                var s = '';
            }

            if(this.h) {
                s = s + '&h=' + this.h;
            }
            if(this.w) {
                s = s + '&w=' + this.w;
            }
            return s;
        },
        width: function() {
            if(this.w) {
                return this.w;
            }

            return 'auto';
        },
        height: function() {
            if(this.h) {
                return this.h;
            }

            return 'auto';
        },
        altText: function() {
            if(this.alt) {
                return this.alt;
            }
            else if(this.img) {
                return this.img.alt;
            }

            return '';
        }
    }
}
</script>
